// ============================================================================
// shared/ui/Button.tsx — Botón con tokens de marca (reemplaza .btn.btn-primario/…).
// Los colores salen de las CSS vars var(--color-button-*) vía el theme de Tailwind,
// así el rebranding multi-tenant de `cambiarColores()` sigue funcionando. El texto
// usa tw-text-white como fallback fijo (el token de texto puede venir vacío). Ver §B.5.
// ============================================================================
import { forwardRef } from "react";
import type { ButtonHTMLAttributes } from "react";

type Variant = "primary" | "secondary";
type Size = "sm" | "md";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const VARIANTES: Record<Variant, string> = {
  primary: "tw-bg-primario hover:tw-bg-primario-hover tw-text-white",
  secondary: "tw-bg-secundario hover:tw-bg-secundario-hover tw-text-white",
};

const TAMANOS: Record<Size, string> = {
  sm: "tw-px-3 tw-py-1 tw-text-sm",
  md: "tw-px-4 tw-py-2 tw-text-base",
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = "primary", size = "sm", className = "", type = "button", ...rest }, ref) => (
    <button
      ref={ref}
      type={type}
      className={`tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-border-0 tw-cursor-pointer tw-transition-colors ${VARIANTES[variant]} ${TAMANOS[size]} ${className}`}
      {...rest}
    />
  ),
);
Button.displayName = "Button";
